const task = {
  state: {
    task: {
      companyCode: "",
      primaryOperationCode: "",
      secondaryOperationCode: "",
    },
    jobs: {
      logo: "",
      JobTitle: "",
      Company: "",
      Salary: "",
      JobLocation: "",
      JobType: "",
      JobDescripton: "",
    },
  },

  mutations: {
    setTask(state, data) {
      state.task = data;
    },
    setJobs(state, data) {
      state.jobs = data;
    },
  },

  getters: {
    getTask: (state) => state.task,
    getJobs: (state) => state.jobs,
  },
};

export default task;
